import React from 'react';

export const useMuiMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const isOpen = Boolean(anchorEl);

  const onOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(null);
  };

  const onItemClick = (action: () => void) => {
    action();
    onClose();
  };

  return {
    anchorEl,
    isOpen,
    onOpen,
    onClose,
    onItemClick,
  };
};
